import {FC, useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {useAppSelector} from 'hooks';
import {PricesModel} from 'types';
import {formatPriceWithCurrency, getIdsFromBasketItems, hasItemsInBasket, isDropShip} from 'utils';
import {isSyncBasketEnabled} from 'utils/helper';

import {FooterView} from './Footer';
import {BasketDrawerFooterProps} from './types';

export const Footer: FC<BasketDrawerFooterProps> = (props) => {
  const {t} = useTranslation();
  const {basket} = useAppSelector((state) => state?.basket);
  const storeSelecteditems = useAppSelector((state) => state?.basket?.selectedItems);
  const localeSelectedItems = JSON.parse(localStorage.getItem('selectedItems') || '[]') || [];
  const isSyncBasket = isSyncBasketEnabled();
  const selectedItems = isSyncBasket ? storeSelecteditems : localeSelectedItems;
  const allItemsInBasket = getIdsFromBasketItems(basket?.basketItems || []);
  const filteredSelectedItem = selectedItems.filter((itm: string) => allItemsInBasket.includes(itm)); //no further need
  const basketTotal = basket?.prices?.totalDisplayPricePostVoucher || 0;
  const isLessThanMinSpend = basketTotal < (basket?.minimumSpend || 0) && !!props.shouldShowMinBasketWarning;
  const isSelectedAllBasketItems = selectedItems?.length === basket?.basketItems?.length;

  const has1PSelected = useMemo<boolean>(() => {
    return !!basket?.basketItems
      ?.filter((item) => selectedItems?.includes(item.productId))
      .some((item) => !isDropShip(item.productDetails?.sellerDetails.marketplaceType));
  }, [basket?.basketItems, selectedItems]);

  const showDeliveryFee = useMemo(() => basketTotal > (basket?.minimumSpend || 0), [basket?.minimumSpend, basketTotal]);

  const showOnly3pShippingFee = !!basket?.prices?.shippingFee3P && (isLessThanMinSpend || !has1PSelected);

  return (
    <FooterView
      deliveryFees={formatPriceWithCurrency(
        showOnly3pShippingFee
          ? (basket?.prices as PricesModel)?.shippingFee3P
          : (basket?.prices as PricesModel)?.shippingFee,
        basket?.priceUnit
      )}
      hasProductInBasket={hasItemsInBasket(basket)}
      basketPrice={{
        label: t('label.total'),
        amount: (basket?.prices?.totalFinalPriceToPay || 0) - (basket?.prices?.shippingFee || 0),
        currency: basket?.priceUnit || 'THB'
      }}
      disableCheckoutBtn={props.isCheckoutDisabled}
      actionButtonLabel={t('button.checkout')}
      onCheckoutClick={props.onCheckoutClick}
      loading={props.loading}
      isLessThanMinSpend={isLessThanMinSpend}
      selectedItems={filteredSelectedItem}
      onClickSelectAllItems={props.onClickSelectAllItems}
      isSelectedAllBasketItems={isSelectedAllBasketItems}
      setShowBasketSummaryModal={props.setShowBasketSummaryModal}
      shouldShowMinBasketWarning={props.shouldShowMinBasketWarning}
      minimumBasket={basket?.minimumSpend}
      showBasketSummaryModal={props.showBasketSummaryModal}
      showDeliveryFee={showDeliveryFee || showOnly3pShippingFee}
    />
  );
};

Footer.displayName = 'Footer';
